import { Box, Button, Grid, TextField, Toolbar, Typography } from '@mui/material'
// import {  Grid } from '@mui/material';
import React from 'react'
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from '../../utils/axiosInstance';
import { toast } from 'react-toastify';
import PasswordVisibility from '../Common/PasswordVisibility';

const ChangePassword = () => {

  const [showPassword, setShowPassword] = React.useState({
    old_password: false,
    new_password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const validationSchema = Yup.object({
    old_password: Yup.string()
      .required("Old password is required"),
    new_password: Yup.string()
      .required("New password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/\d/, "Password must contain at least one number")
      .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const formik = useFormik({
    initialValues: {
      old_password: "",
      new_password: "",
      confirmPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const response = await axiosInstance.post('/users/change-password', values);
        if (response.status === 204) {
          formik.resetForm();
          toast.success("Password changed successfully")
        }
      } catch (error) {
        console.error(error);
      }
    },
  });
  return (
    <>
      <Toolbar
        className='main-list-toolbar'
      >
        <Typography
          className="d-flex flex-grow-1 flex-shrink-1 flex-fill"
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Change Password
        </Typography>
      </Toolbar>
      <Grid container >
        <Box
          component="form"
          onSubmit={formik.handleSubmit}
          className='mw-100'
        >

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextField
              required
              fullWidth
              id="old_password"
              name="old_password"
              label="Old Password"
              type={showPassword.old_password ? "text" : "password"}
              margin="normal"
              variant="outlined"
              value={formik.values.old_password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.old_password && Boolean(formik.errors.old_password)}
              helperText={formik.touched.old_password && formik.errors.old_password}
              InputProps={{
                endAdornment: (
                  <PasswordVisibility
                    showPassword={showPassword.old_password}
                    onToggle={() => togglePasswordVisibility("old_password")}
                  />
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextField
              required
              fullWidth
              id="new_password"
              name="new_password"
              label="New Password"
              type={showPassword.new_password ? "text" : "password"}
              margin="normal"
              variant="outlined"
              value={formik.values.new_password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.new_password && Boolean(formik.errors.new_password)}
              helperText={formik.touched.new_password && formik.errors.new_password}
              InputProps={{
                endAdornment: (
                  <PasswordVisibility
                    showPassword={showPassword.new_password}
                    onToggle={() => togglePasswordVisibility("new_password")}
                  />
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={12}>
            <TextField
              required
              fullWidth
              id="confirmPassword"
              name="confirmPassword"
              label="Confirm Password"
              type={showPassword.confirmPassword ? "text" : "password"}
              margin="normal"
              variant="outlined"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
              helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
              InputProps={{
                endAdornment: (
                  <PasswordVisibility
                    showPassword={showPassword.confirmPassword}
                    onToggle={() => togglePasswordVisibility("confirmPassword")}
                  />
                ),
              }}
            />
          </Grid>
          <Box display="flex" gap={2} justifyContent="flex-end" className="mt-4">
            <Button type="submit" variant="contained" disabled={!(formik.dirty && formik.isValid) || formik.isSubmitting}>
              Save
            </Button>
          </Box>
        </Box>
      </Grid>
    </>
  )
}

export default ChangePassword